import api from './api';
import { ManagedUser } from '../types/auth';
import { Reimbursement, ReimbursementStatus, VacationRequest, VacationStatus } from '../types/collaborator';

export interface HRReimbursement extends Reimbursement {
    user_id: number;
    user_name: string;
    review_notes?: string | null;
    reviewed_at?: string | null;
}

export interface HRVacation extends VacationRequest {
    user_id: number;
    user_name: string;
    days: number;
    conflicts: string[];
    review_notes?: string | null;
}

export interface HRSummaryReport {
    period: { start: string; end: string };
    headcount: Record<string, number>;
    hours: {
        total: number;
        by_project: { project_name: string; hours: number }[];
        by_person: { user_name: string; hours: number }[];
        entries: { date: string; user_name: string; project_name: string; hours: number; description: string }[];
    };
    reimbursements: Record<string, { count: number; amount: number }>;
    vacations: { user_name: string; start_date: string; end_date: string; business_days_in_period: number }[];
}

export const hrService = {
    // Usuários (cadastro feito pelo RH/Diretor)
    async listUsers(): Promise<ManagedUser[]> {
        return (await api.get('/api/users')).data;
    },
    async createUser(data: { name: string; email: string; role: string; password: string }): Promise<ManagedUser> {
        return (await api.post('/api/users', data)).data;
    },
    async updateUser(id: number, data: Partial<Pick<ManagedUser, 'name' | 'role' | 'is_active'>>): Promise<ManagedUser> {
        return (await api.put(`/api/users/${id}`, data)).data;
    },
    async resetPassword(id: number, password: string): Promise<ManagedUser> {
        return (await api.post(`/api/users/${id}/reset-password`, { password })).data;
    },

    // Aprovações
    async listReimbursements(status?: ReimbursementStatus): Promise<HRReimbursement[]> {
        return (await api.get('/api/hr/reimbursements', { params: status ? { status } : {} })).data;
    },
    async decideReimbursement(id: number, status: ReimbursementStatus, notes?: string): Promise<void> {
        await api.post(`/api/hr/reimbursements/${id}/decision`, { status, notes });
    },
    async listVacations(status?: VacationStatus): Promise<HRVacation[]> {
        return (await api.get('/api/hr/vacations', { params: status ? { status } : {} })).data;
    },
    async decideVacation(id: number, status: VacationStatus, notes?: string): Promise<void> {
        await api.post(`/api/hr/vacations/${id}/decision`, { status, notes });
    },

    // Relatórios
    async summary(start: string, end: string): Promise<HRSummaryReport> {
        return (await api.get('/api/hr/reports/summary', { params: { start, end } })).data;
    },
};

export const apiErrorMessage = (err: any, fallback: string) => err?.response?.data?.error || fallback;
